<template>
  <div>
    <div class="m10 fs24 fw500" v-if="showTitle">
      {{ inConfig.name }}
      <div v-if="inConfig.remarks" class="fs16" style="color: #909399">
        {{ inConfig.remarks }}
      </div>
    </div>

    <!-- 数据统计部分 -->
    <div class="kuai box-s ac wrap" v-if="page_data && page_data.statistics">
      <div v-for="(item, index) in page_data.statistics" :key="index">
        <span class="mr20"> {{ item.name }} {{ item.value }} </span>
      </div>
    </div>

    <!-- 搜索部分 -->
    <div class="kuai box-s" v-if="inConfig.search_config && inConfig.search_config.length > 0" :key="search_key">
      <div class="subtitle mb10">数据搜索</div>
      <div class="ac wrap">
        <div v-for="(item, index) in inConfig.search_config" :key="index" class="ac">
          <div class="ml10 mr4 fs14" style="white-space: nowrap">{{ item.title }}:</div>

          <div v-if="item.type == '下拉单选'">
            <el-select v-model="post_data[item.key]" placeholder="请选择" filterable @change="inputSearch">
              <el-option v-for="(option, index) in item.options" :key="index" :label="option" :value="option"></el-option>
            </el-select>
          </div>

          <div v-else-if="item.type == '按钮单选'">
            <el-radio-group v-model="post_data[item.key]" size="medium" @change="inputSearch">
              <el-radio-button :label="option.name" v-for="(option, index) in item.content" :key="index"></el-radio-button>
            </el-radio-group>
          </div>

          <div v-else-if="item.type == '日期时间'">
            <el-date-picker v-model="post_data[item.key]" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"> </el-date-picker>
          </div>

          <div v-else-if="item.type == '月份选择'">
            <el-date-picker v-model="post_data[item.key]" type="month" format="yyyy-MM" value-format="yyyy-MM" placeholder="选择月份"> </el-date-picker>
          </div>

          <div v-else-if="item.type == '开始结束时间'">
            <el-date-picker
              v-model="post_data[item.key]"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
          <el-input v-model="post_data[item.key]" @change="inputSearch" v-else placeholder="请输入"></el-input>
        </div>

        <el-button type="success" size="small" class="ml20" @click="Search">查询</el-button>
        <el-button plain @click="resetSearch" class="ml10" size="small">重置</el-button>
      </div>
    </div>

    <!-- 表格主体 -->

    <div class="kuai box-s" v-if="page_data">
      <div class="acsb">
        <!-- 单选按钮 -->
        <div v-if="page_data.select_btn">
          <el-radio-group v-model="post_data[page_data.select_btn_key]" size="medium" @change="inputSearch">
            <el-radio-button :label="option.name" v-for="(option, index) in page_data.select_btn" :key="index"></el-radio-button>
          </el-radio-group>
        </div>

        <!-- 按钮组 -->
        <div class="mb10 ac wrap">
          <div v-for="(btn, bindex) in inConfig.btns" :key="bindex">
            <el-button :type="btn.type" :size="btn.size" @click="$emit('event', {row: btn, event: btn.event})">{{ btn.name }}</el-button>
          </div>
        </div>

        <div v-if="page_data.other_info" class="fw600">
          {{ page_data.other_info }}
        </div>
      </div>

      <el-table :data="page_data.items" stripe style="width: 100%" @sort-change="sortChange" @selection-change="handleSelectionChange">
        <!-- 默认的id -->
        <el-table-column type="selection" width="55" v-if="select"> </el-table-column>
        <el-table-column prop="id" label="id" width="60" sortable v-if="page_data.items && page_data.items.length > 0 && page_data.items[0].id"></el-table-column>
        <!-- 自定义的内容显示 -->

        <el-table-column :prop="item.key" :label="item.title" v-for="(item, index) in inConfig.table_config" :key="index" :sortable="item.key == 'balance' ? 'custom' : item.order" :width="item.width">
          <template slot-scope="scope">
            <!-- 如果是数据显示 -->
            <div v-if="item.row_type == 'str'">
              <div v-if="item.content.show_type == 'avatar'">
                <img :src="scope.row[item.key]" class="avatar box-s" alt="" v-if="scope.row[item.key] && scope.row[item.key] != ''" />
              </div>

              <div v-else @click="$copy(scope.row[item.key])" :style="getColumnStyle(item)">
                {{ scope.row[item.key] }}
              </div>
            </div>
            <!-- 如果是开关 -->
            <div v-else-if="item.row_type == 'switch'">
              <el-switch v-model="scope.row[item.key]" @change="event_func(scope.row, item.event)"></el-switch>
            </div>

            <!-- 如果是按钮 -->
            <div v-else-if="item.row_type == 'btn'">
              <!-- {{ item }} -->
              <!-- {{ item }} -->
              <el-button class="mb2" :type="getBtnType(item.event)" size="mini" @click="event_func(scope.row, item.event)">{{ item.key }}</el-button>
            </div>
            <div v-else-if="item.row_type == 'input'">
              <el-input v-model="scope.row[item.key]" placeholder="请输入"></el-input>
            </div>

            <div v-else>
              {{ item.row_type }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页功能 -->
    <div class="m20 acsb" v-if="page_data">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="post_data.page"
        :page-sizes="[10, 20, 100, 200, 300, 400]"
        :page-size="post_data.per_page"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page_data.total"
      >
      </el-pagination>

      <div class="fs14" style="color: #909399">数据加载时间：{{ page_data.processingTime }} 秒</div>
    </div>
  </div>
</template>

<script>
import {http_post, http_get} from '@/api/api'
import {h} from 'vue'

export default {
  props: {
    inConfig: {
      type: [Array, Object],
      default: () => null
    },
    defaultConfig: {
      // 默认的搜索条件
      type: [Array, Object],
      default: () => null
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    select: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      search_key: 0,
      post_data: null,
      page_data: null,
      search_config: {
        page: 1,
        per_page: 10
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },

  created() {
    if (this.inConfig.search_config) {
      this.inConfig.search_config.forEach(item => {
        if (!item.type) {
          this.search_config[item.key] = ''
        } else if (item.type == 'radio-btn' || item.type == 'radio') {
          this.search_config[item.key] = item.options[0]
        }
        // console.log(item)
        if (item.default && item.type != '下拉单选') {
          this.search_config[item.key] = item.default
        }
        if (item.type == '下拉单选') {
          this.search_config[item.key] = ''
          this.getOptions(item.option_url, item)
        }
      })
    }

    if (this.defaultConfig) {
      Object.keys(this.defaultConfig).forEach(key => {
        this.search_config[key] = this.defaultConfig[key]
      })
    }

    this.post_data = JSON.parse(JSON.stringify(this.search_config))
    this.Search()
  },

  methods: {
    getBtnType(e) {
      if (e == '保存') {
        return 'success'
      } else if (e == '删除') {
        return 'danger'
      } else {
        return 'primary'
      }
    },
    getOptions(url, item) {
      http_get(url).then(res => {
        item.options = res.data
      })
    },
    handleSelectionChange(e) {
      this.$emit('select', e)
    },
    getColumnStyle(e) {
      if (e.color) {
        return {
          color: e.color
        }
      } else {
        return {}
      }
    },
    event_func(row, e) {
      // console.log(row, e)
      if (e == 'save') {
        this.update_func(row)
      } else if (e == 'del') {
        this.del_func(row)
      } else {
        this.$emit('event', {row: row, event: e})
      }
    },

    del_func(item) {
      this.$confirm('确认删除？')
        .then(_ => {
          http_post(this.inConfig.del_api, {id: item.id}, 1).then(res => {
            if (res.code == 200) {
              this.Search()
            }
          })
        })
        .catch(_ => {})
    },
    inputSearch() {
      this.post_data.page = 1
      this.Search()
    },
    update_func(item) {
      http_post(this.inConfig.update_api, item, 1).then(res => {
        this.Search()
      })
    },

    // 重置搜索
    resetSearch() {
      this.search_key += 1
      this.post_data = JSON.parse(JSON.stringify(this.search_config))
      this.Search()
    },
    // 分页相关
    Search() {
      http_post(this.inConfig.list_api, this.post_data, 1).then(res => {
        // console.log(res)
        this.page_data = res.data
        this.page_data.processingTime = res.processingTime
        if (res.data.per_page == 1) {
          this.post_data.per_page = res.data.total
        }

        if (res.data.select_btn) {
          console.log(res.data.select_btn_key)
          if (!this.post_data[res.data.select_btn_key]) {
            this.post_data[res.data.select_btn_key] = res.data.select_btn[0]['name']
          }
        }
      })
    },
    // 每页x条
    sizeChange(val) {
      // console.log(`每页 ${val} 条`)
      this.post_data.per_page = val
      this.Search()
    },
    //跳转某页
    currentChange(val) {
      // console.log(`当前页: ${val}`)
      this.post_data.page = val
      this.Search()
    },
    // 修改排序
    sortChange(column) {
      this.post_data.prop = column.prop
      this.post_data.order = column.order
      this.post_data.page = 1
      this.Search()
    }
  }
}
</script>

<style lang="scss" scoped></style>
